import React from 'react';
import { WebhookInfo } from 'common/types/api';
import { translateWebhookEvent, getPayloadTypeForWebhookEvent } from 'common/utils/webhooks';
import { ApiDocsTagUrl } from 'common/constants/api';

import { Table, TableHead, TableBody, TableRow, TableCell, IconButton } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { useTranslation } from 'services/localization';
import ExternalLinkButton from 'common/components/ExternalLinkButton';
import { api } from 'common/frontend/api';

interface Props {
	data: WebhookInfo[];
	shopId: string;
}

const WebhooksTable = (props: Props) => {
	const { t } = useTranslation();

	const handleDelete = (id: string) => {
		api().shops.doc(props.shopId).webhooks.doc(id).delete();
	};

	return (
		<Table>
			<TableHead>
				<TableRow>
					<TableCell>{t('Integrations.Webhooks.WebhooksTable.label', 'Label')}</TableCell>
					<TableCell>{t('Integrations.Webhooks.WebhooksTable.trigger', 'Trigger')}</TableCell>
					<TableCell>{t('Integrations.Webhooks.WebhooksTable.url', 'URL')}</TableCell>
					<TableCell>
						{t('Integrations.Webhooks.WebhooksTable.payloadType', 'Payload type')}
					</TableCell>
					<TableCell></TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{props.data.map((webhook) => (
					<TableRow key={webhook.id}>
						<TableCell>{webhook.label}</TableCell>
						<TableCell>{translateWebhookEvent(webhook.event, t)}</TableCell>
						<TableCell>{webhook.urls.join(', ')}</TableCell>
						<TableCell>
							<ExternalLinkButton
								href={ApiDocsTagUrl(getPayloadTypeForWebhookEvent(webhook.event))}
								text={getPayloadTypeForWebhookEvent(webhook.event)}
							/>
						</TableCell>
						<TableCell>
							<IconButton onClick={() => handleDelete(webhook.id)} size="large">
								<DeleteIcon />
							</IconButton>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

export default WebhooksTable;
